module.exports = __webpack_public_path__ + "static/media/Pidgeot_gaussian2.d382873a.png";